import * as actionTypes from './actionTypes';
import { 
    getVendorsListApi,
    submitTaskApi,
    getProjApolloAcctNos,
    getProjApolloCustNames,
    getProjApolloChargeDescs,
    postValidatVendorNAcctNoApi,
    getProjApolloServiceAddresses,
    getApolloItemsApi,
    createApolloItemApi,
    updateApolloItemApi,
    moveDownApolloItemApi,
    moveUpApolloItemApi,
    deleteApolloItemApi
 } from '../../apiUtils/api';
import { formatMomentObjectWithValue,stringDate2MomentObject,US_DATE_FORMAT } from '../../Utils/dateUtil'

export const openAddInvItemForm=()=>{
    return { type: actionTypes.OPEN_ADD_INV_ITEM_FORM };
}

export const cancelAddInvItemForm=()=>{
    return { type: actionTypes.CANCEL_ADD_INV_ITEM_FORM };
}

export const addNewInvoiceItem=(newInvoiceItem)=>{
    return { type: actionTypes.ADD_NEW_INV_ITEM, newInvoiceItem };
}

export const updateEditInvoiceItem=(newInvoiceItem)=>{
    return { type: actionTypes.UPDATE_EDIT_INV_ITEM, newInvoiceItem };
}

export const invItemSelected=(index)=>{
    return { type: actionTypes.INV_ITEM_SELECTED, invoiceItemSelectedIndex: index};
}

export const invItemDeselected=()=>{
    return { type: actionTypes.INV_ITEM_DESELECTED };
}

export const removeAnInvoiceItem=(currentInvItems,index)=>{
    let invItems=currentInvItems;
    invItems.splice(index, 1);
    //Reindex
    let newInvItems=[];
    let i=-1;
    invItems.forEach((item)=>{
        let newItem=item;
        newItem.id=i;
        newInvItems.push(newItem);
        i++;
    })

    return { type: actionTypes.UPDATE_INV_ITEMS, invoiceItems: newInvItems };
}

export const populateVendorsList=()=>{
    return dispatch => getVendorsListApi().then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_API_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATE_INV_VENDORS, invoiceVendors: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_API_ERROR, error: err});
    })
}

export const refreshAcctNos=(jwt,vendorCode)=>{
    return dispatch => getProjApolloAcctNos(jwt,vendorCode).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_API_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_INV_ACCT_NOS, invoiceAcctNos: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_API_ERROR, error: err});
    })
}

export const refreshCustNames=(jwt,vendorCode,acctNo)=>{
    return dispatch => getProjApolloCustNames(jwt,vendorCode,acctNo).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_API_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_INV_CUST_NAMES, invoiceCustNames: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_API_ERROR, error: err});
    })
}

export const refreshChargeDescs=(jwt,vendorCode,acctNo)=>{
    return dispatch => getProjApolloChargeDescs(jwt,vendorCode,acctNo).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_API_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_INV_CHARGE_DESCS, invItemChargeDescs: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_API_ERROR, error: err});
    })
}

export const refreshServiceAddress=(jwt,vendorCode,acctNo)=>{
    return dispatch => getProjApolloServiceAddresses(jwt,vendorCode,acctNo).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_API_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_INV_SERVICE_ADDRESSES, invItemServiceAddrs: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_API_ERROR, error: err});
    })
}

export const invoiceSubmission = (jwt,taskAcceptedInfoId,invoiceHeader)=>{
    let payload={};
    
    let inputInvoiceHeader=invoiceHeader
    if (inputInvoiceHeader.hdrInvDate){
        inputInvoiceHeader.hdrInvDate=formatMomentObjectWithValue(inputInvoiceHeader.hdrInvDate,'MM/DD/YYYY')
    }
    if (inputInvoiceHeader.hdrPayDate){
        inputInvoiceHeader.hdrPayDate=formatMomentObjectWithValue(inputInvoiceHeader.hdrPayDate,'MM/DD/YYYY')
    }

    payload.invoiceHeader=inputInvoiceHeader;
    payload.taskAcceptedInfoId=taskAcceptedInfoId;

    return dispatch => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.INV_SUBMITTED_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.INV_SUBMITTED_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.INV_SUBMITTED_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.INV_SUBMITTED_COMPLETED };
}

export const validateVendorNAcctNo = (jwt,vendorCode,acctNo)=>{
    let payload={};
    payload.vendorCode=vendorCode;
    payload.acctNo=acctNo;

    return dispatch => postValidatVendorNAcctNoApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        //console.log(data)
        if (data.error) {
            //console.log(data.error)
            dispatch({type: actionTypes.INV_VALIDATE_VENDOR_N_ACCTNO_ERROR, error: data.error});
        }else {
            dispatch({
                type: actionTypes.INV_VALIDATE_VENDOR_N_ACCTNO_SUCCESS, 
                docTemplLines: data.docTemplLines,
                validatedVendorCode: vendorCode,
                validatedAcctNo: acctNo
            });
        }
    }).catch((err)=> {
        console.log(err);
        dispatch({type: actionTypes.INV_VALIDATE_VENDOR_N_ACCTNO_ERROR, error: err});
    })
}

export const clearValidation = () => {
    return { type: actionTypes.INV_CLEAR_VALIDATION };
}

export const selectedInvVendor=(code,vendors)=>{
    let search = vendors.find(x=>x.code===code);
    if (search){
        return { type: actionTypes.SELECTED_INV_VENDOR, invoiceVendor: search };
    }else {
        return { type: actionTypes.CLEAR_INV_VENDOR };
    }
}

export const clearInvVendor=()=>{
    return { type: actionTypes.CLEAR_INV_VENDOR };
}

export const clearAllInvoiceItems=()=>{
    return { type: actionTypes.CLEAR_ALL_INV_ITEMS };
}

export const setInvAcctNo=(invAcctNo)=>{
    return { type: actionTypes.SET_INV_ACCT_NO, invAcctNo: invAcctNo};
}

export const clearInvAcctNo=()=>{
    return { type: actionTypes.CLEAR_INV_ACCT_NO };
}

export const saveInvoiceHeader=(invoiceHeader)=>{
    return { type: actionTypes.SAVE_INV_HEADER, invoiceHeader: invoiceHeader };
}

export const getApolloItems=(jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId)=>{
    return dispatch => getApolloItemsApi(jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_APOLLO_ITEMS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_APOLLO_ITEMS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_APOLLO_ITEMS_ERROR,error: err});
    })
}

export const setPage=(jwt,projApollo,page)=>{
    return getApolloItems(jwt,page,projApollo.pageSize,projApollo.sortField,projApollo.sortOrder,projApollo.taskAcceptedInfoId);
}

export const setPageSize=(jwt,projApollo,pageSize)=>{
    return getApolloItems(jwt,projApollo.page,pageSize,projApollo.sortField,projApollo.sortOrder,projApollo.taskAcceptedInfoId);
}

export const sortData=(jwt,projApollo,sortField,sortOrder)=>{
    return getApolloItems(jwt,projApollo.page,projApollo.pageSize,sortField,sortOrder,projApollo.taskAcceptedInfoId);
}

export const createNewApolloItem=(jwt,newApolloItem,taskAcceptedInfoId)=>{
    let payload=newApolloItem
    //Transform DatePicker moment value to valid string format
    if (payload && payload.colQBillingStartDate){
        let colQBillingStartDate= formatMomentObjectWithValue(payload.colQBillingStartDate,'MM/DD/YYYY')
        payload.colQBillingStartDate=colQBillingStartDate
    }
    if (payload && payload.colRBillingEndDate){
        let colRBillingEndDate= formatMomentObjectWithValue(payload.colRBillingEndDate,'MM/DD/YYYY')
        payload.colRBillingEndDate=colRBillingEndDate
    }

    return dispatch => createApolloItemApi(jwt,payload,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.NEW_APOLLO_ITEM_CREATED_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.NEW_APOLLO_ITEM_CREATED, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.NEW_APOLLO_ITEM_CREATED_ERROR,error: err});
    })
}

export const editApolloItem=(apolloItem)=>{
    let convertToFormObj={};
    convertToFormObj.id=apolloItem.id;
    convertToFormObj.colHHdrAcctNo=apolloItem.hdr_acct_no;
    convertToFormObj.colIHdrTotal=apolloItem.hdr_total;
    convertToFormObj.colJHdrConsump=apolloItem.hdr_consumption;
    convertToFormObj.colKHdrConsumpUnits=apolloItem.hdr_consumption_unit;
    convertToFormObj.colLChargeDesc=apolloItem.item_charge_desc;
    convertToFormObj.colMCharge=apolloItem.item_charge;
    convertToFormObj.colNConsump=apolloItem.item_consumption;
    convertToFormObj.colOConsumpUnit=apolloItem.item_consumption_unit;
    convertToFormObj.colPServiceAddress=apolloItem.item_service_addr;
    convertToFormObj.colQBillingStartDate=apolloItem.item_bill_start_date?stringDate2MomentObject(apolloItem.item_bill_start_date,US_DATE_FORMAT):null;
    convertToFormObj.colRBillingEndDate=apolloItem.item_bill_end_date?stringDate2MomentObject(apolloItem.item_bill_end_date,US_DATE_FORMAT):null;
    convertToFormObj.colSPartialFinal=apolloItem.item_partial_or_final;
    convertToFormObj.colTDaysOfService=apolloItem.item_days_of_service;
    convertToFormObj.isOverrideColLChargeDesc=apolloItem.is_override_item_charge_desc;
    convertToFormObj.isOverrideColPServiceAddress=apolloItem.is_override_item_service_addr;
    
    return { type: actionTypes.EDIT_APOLLO_ITEM, apolloItem: convertToFormObj };
}

export const updateApolloItem=(jwt,updateApolloItem,id)=>{
    let payload=updateApolloItem
    //Transform DatePicker moment value to valid string format
    if (payload && payload.colQBillingStartDate){
        let colQBillingStartDate= formatMomentObjectWithValue(payload.colQBillingStartDate,'MM/DD/YYYY')
        payload.colQBillingStartDate=colQBillingStartDate
    }
    if (payload && payload.colRBillingEndDate){
        let colRBillingEndDate= formatMomentObjectWithValue(payload.colRBillingEndDate,'MM/DD/YYYY')
        payload.colRBillingEndDate=colRBillingEndDate
    }

    return dispatch => updateApolloItemApi(jwt,payload,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATED_APOLLO_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATED_APOLLO_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATED_APOLLO_ITEM_ERROR,error: err});
    })
}

export const moveDownApolloItem=(jwt,id)=>{
    return dispatch => moveDownApolloItemApi(jwt,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_DOWN_APOLLO_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_DOWN_APOLLO_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_DOWN_APOLLO_ITEM_ERROR,error: err});
    })
}

export const moveUpApolloItem=(jwt,id)=>{
    return dispatch => moveUpApolloItemApi(jwt,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_UP_APOLLO_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_UP_APOLLO_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_UP_APOLLO_ITEM_ERROR,error: err});
    })
}

export const deleteApolloItem=(jwt,id)=>{
    return dispatch => deleteApolloItemApi(jwt,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.DELETE_APOLLO_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.DELETE_APOLLO_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DELETE_APOLLO_ITEM_ERROR,error: err});
    })
}

export const selectApolloItemId=(id)=>{
    return { type: actionTypes.SELECTED_APOLLO_ITEM_ID, id};
}


// WEBPACK FOOTER //
// ./src/redux/projApollo/actions.js